import isMobile from 'ismobilejs/esm';

export default defineNuxtPlugin(nuxtApp => {
	const userAgent = process.server ? useRequestHeader('user-agent') : navigator.userAgent;
	const isMobileInstance = isMobile(userAgent || 'unknown');
	nuxtApp.provide('isMobile', isMobileInstance);
});
